import { useMemo } from "react"

/*
 * this hook returns a promise and a function that will resolve the promise
 */
export function usePromise<T>(): [Promise<T>, (v: T) => void] {
  return useMemo(
    () => {

      let resolve: (v: T) => void = () => {}
      const promise = new Promise<T>((r) => (resolve = r))
      return [
        promise,
        resolve,
      ]
    },
    [],
  )
}
